import {
  Gauge, Zap, Wrench, Cog, Hammer, Scissors, Activity, HardHat,
} from "lucide-react";

const FLEET = [
  { name: "JCB Backhoe Loader", role: "Excavation, levelling, backfilling and material handling.", why: "The first machine on site and the busiest one till handover.", img: "/img/equipment-jcb-backhoe.png" },
  { name: "DTH Piling Rig", role: "Down-the-hole hammer drilling for pile foundations in hard and rocky strata.", why: "Built for Rajasthan's toughest terrain, where augers alone give up.", img: "/img/equipment-dth-piling-rig.png" },
  { name: "JCB-Mounted Piling Machine", role: "Rapid pile drilling using a JCB-mounted attachment.", why: "Flexible piling capacity that moves across blocks quickly.", img: "/img/equipment-jcb-piling.png" },
  { name: "Hydraulic Auger Machine", role: "High-speed foundation drilling in normal soil strata.", why: "Keeps the piling front ahead of the structure-erection front.", img: "/img/equipment-hydraulic-auger.png" },
  { name: "AJAX Self-Loading Concrete Mixer (Cabin)", role: "On-site batching, mixing and pouring for pile grouting and foundations.", why: "No waiting on transit mixers in remote locations.", img: "/img/equipment-ajax-mixer.png" },
  { name: "Transformer Oil Filtration Machine", role: "On-site oil filtration and dehydration for transformers.", why: "An electrical contractor's machine — ready for charging-stage work.", img: "/img/equipment-oil-filtration.png" },
  { name: "Tractors with Trolleys", role: "Material shifting, water supply and site logistics.", why: "The workhorses that keep every front fed.", img: "/img/equipment-tractor-trolley.png" },
  { name: "Site Campers", role: "Company-owned accommodation units for crews at remote sites.", why: "Self-sufficient mobilisation — our teams arrive with their own boarding and lodging.", img: "/img/equipment-site-campers.png" },
];

const INSTRUMENTS = [
  { i: Gauge, t: "Megger / Insulation Resistance Testers" },
  { i: Activity, t: "Earth Resistance Testers" },
  { i: Cog, t: "Ferrule Printing Machine" },
  { i: Hammer, t: "Drilling Machines" },
  { i: Scissors, t: "Cutting Machines" },
  { i: Wrench, t: "Crimping & Torque Tools" },
  { i: Zap, t: "Multimeters & Clamp Meters" },
  { i: HardHat, t: "Full PPE & Electrical Safety Kit" },
];

const OWNED_FLEET_MEANS = [
  { t: "Mobilisation in days, not weeks.", d: "Machines move on our decision — no rental-yard availability risk." },
  { t: "Operators who know their machines.", d: "Our crews run equipment they maintain, so uptime stays high." },
  { t: "Schedule control where it matters.", d: "Piling and earth work sit on the critical path; owning that capacity protects your COD." },
];

export function EquipmentHero() {
  return (
    <section className="ye-page-hero">
      <div className="ye-container">
        <span className="ye-eyebrow">Equipment & Fleet</span>
        <h1 className="ye-display ye-h1" style={{ margin: "8px 0 18px" }}>Most Contractors Hire Machines. We Own Ours.</h1>
        <p style={{ maxWidth: 880, fontSize: 17, color: "rgba(255,255,255,0.9)" }}>
          Every machine below is on Yaduraj&apos;s own books — maintained by us, operated by our people, and mobilised on our schedule. That&apos;s the difference between promising a date and holding one.
        </p>
      </div>
    </section>
  );
}

function FleetCard({ machine }) {
  return (
    <div className="ye-fleet-card" data-testid={`fleet-${machine.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
      <div className="ye-fleet-photo"><img loading="lazy" src={machine.img} alt={machine.name} /></div>
      <div className="ye-fleet-body">
        <h3 className="ye-h3" style={{ fontSize: "1.05rem", margin: "0 0 6px" }}>{machine.name}</h3>
        <div className="ye-fleet-role">{machine.role}</div>
        <div className="ye-fleet-why">{machine.why}</div>
      </div>
    </div>
  );
}

export function EquipmentFleetGrid() {
  return (
    <section className="ye-section">
      <div className="ye-container">
        <div className="ye-grid-4">
          {FLEET.map((f) => <FleetCard key={f.name} machine={f} />)}
        </div>
      </div>
    </section>
  );
}

function InstrumentItem({ icon: Icon, label }) {
  return (
    <div className="ye-instrument"><span className="icon"><Icon size={22} /></span>{label}</div>
  );
}

export function InstrumentsGrid() {
  return (
    <section className="ye-section ye-section--bg">
      <div className="ye-container">
        <div style={{ marginBottom: 28 }}>
          <span className="ye-eyebrow">Instruments & Tooling</span>
          <h2 className="ye-display ye-h2" style={{ margin: "6px 0 0" }}>Calibrated For Commissioning</h2>
        </div>
        <div className="ye-instrument-grid">
          {INSTRUMENTS.map((it) => <InstrumentItem key={it.t} icon={it.i} label={it.t} />)}
        </div>
      </div>
    </section>
  );
}

export function OwnedFleetMeaning() {
  return (
    <section className="ye-section">
      <div className="ye-container">
        <div style={{ textAlign: "center", marginBottom: 36 }}>
          <h2 className="ye-display ye-h2" style={{ margin: 0 }}>What an Owned Fleet Means for Your Project</h2>
        </div>
        <div className="ye-grid-3">
          {OWNED_FLEET_MEANS.map((b) => (
            <div className="ye-card" key={b.t}>
              <h3 className="ye-h3" style={{ margin: "0 0 8px" }}>{b.t}</h3>
              <p style={{ margin: 0 }}>{b.d}</p>
            </div>
          ))}
        </div>
        <p style={{ marginTop: 36, fontStyle: "italic", color: "#5b6577", textAlign: "center", fontSize: 14 }}>
          Equipment photographs shown are representative; a full fleet dossier with registration and ownership records is available on request.
        </p>
      </div>
    </section>
  );
}
